export default function (value, width, height) {
    return value.includes('?') ? `${value}&width=${width}&height=${height}` : `${value}?width=${width}&height=${height}`;
}
